import dayjs, { Dayjs } from 'dayjs'
import { LoyaltyCardType, StoreType, LoyaltyCustomerListItem } from './types'

export type LoyaltySource = 'in_store' | 'online' | undefined

// getLoyaltyCustomersListCount's own vocabulary differs from ours.
export const toLoyaltySourceParam = (
  loyaltySource: LoyaltySource
): string | undefined => {
  if (loyaltySource === 'in_store') return 'partner_scan'
  if (loyaltySource === 'online') return 'customer'
  return undefined
}

export const isExpired = (
  loyalty_card: LoyaltyCardType,
  currentDay: Dayjs,
  timezone = 'Europe/London'
) => {
  const now = currentDay.utc().tz(timezone)
  if (!loyalty_card?.ends_at) return false
  const expiration = dayjs.utc(loyalty_card.ends_at).tz(timezone)
  return expiration.isBefore(now)
}

export const stringListForMutation = (
  currentList?: string[],
  stringList?: string[]
) => {
  if (!stringList && !currentList) return '{}'

  if (!stringList) return `{${currentList?.join(',')}}`

  return `{${stringList?.join(',')}}`
}

export const filterStoresForQR = (
  stores: StoreType[],
  allStoresEnabled: boolean,
  currentStoreIds?: string[]
) => {
  if (allStoresEnabled) return stores

  if (!currentStoreIds) return stores

  return stores.filter((store: StoreType) =>
    currentStoreIds?.includes(store.id)
  )
}

type SourceFilterable = Pick<
  LoyaltyCustomerListItem,
  | 'periodStampsInStore'
  | 'periodRewardsInStore'
  | 'periodStampsOnline'
  | 'periodRewardsOnline'
>

export const applyLoyaltySourceFilter = <T extends SourceFilterable>(
  list: T[],
  loyaltySource: LoyaltySource
): T[] => {
  if (!loyaltySource) return list
  if (loyaltySource === 'in_store')
    return list.filter(
      (c) =>
        (c.periodStampsInStore ?? 0) > 0 || (c.periodRewardsInStore ?? 0) > 0
    )
  if (loyaltySource === 'online')
    return list.filter(
      (c) => (c.periodStampsOnline ?? 0) > 0 || (c.periodRewardsOnline ?? 0) > 0
    )
  return list
}

export const BulkRewardImportFile = (file: File) => {
  return new Promise((resolve) => {
    const fileReader = new FileReader()
    fileReader.readAsText(file)
    fileReader.onloadend = () => {
      return resolve(fileReader.result as string)
    }
  })
}
